<template>
  <div class="comm">
    <h4>{{ commTotalCount }} 评论</h4>
    <div class="">
      <el-input type="textarea" :placeholder="hits == null ? '请输入内容' : hits" :rows="4" maxlength="120" v-model="rplcont"
        show-word-limit>
      </el-input>
      <div class="replybtns">
        <el-button type="primary" @click="reply($event, 0, 0, '', publishUserId, 1, 0)" plain>{{
        btnText== null ? "发表回复" : btnText }}</el-button>
      </div>
      <div style="clear: both"></div>
      <!--一级评论-->
      <div class="comm-cont" v-for="(item, index) in commList" :key="index">
        <div>
          <div class="avatar">
            <el-avatar :size="sizeList[1]" :src="circleUrl"></el-avatar>
          </div>
          <div class="comm-detail">
            <span class="name">{{ item.displayname }}</span>
            <!-- <a href="/">查看评论</a> -->
            <div class="cont">{{ item.cont }}</div>
            <div class="date">
              {{
                dateFormat(item.create_date)
              }}<a href="##" v-on:click="repleyShow($event)">回复</a>
              <!-- <a href="#">举报</a> -->
              <!-- <a href="#">删除</a> -->
            </div>
            <div class="replyarea">
              <el-input type="textarea" placeholder="请输入内容" :rows="4" v-model="rplcont2" maxlength="120"
                show-word-limit>
              </el-input>
              <div class="replybtns">
                <el-button type="primary" @click="
                  reply(
                    $event,
                    item.id,
                    item.comment_id == 0 ? item.id : item.comment_id,
                    item.displayname,
                    item.uid,
                    2,
                    index
                  )
                " plain>发表回复</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 二级评论 -->
        <div class="comm-level2" v-for="(item2, index2) in childCommList[index]" :key="index2">
          <div>
            <div class="avatar-level2">
              <el-avatar :size="sizeList[2]" :src="circleUrl"></el-avatar>
            </div>
            <div class="comm-detail">
              <span class="name">{{ item2.replied_name }}</span> 回复
              <span class="name"> @{{ item2.displayname }}</span> 的评论
              <div class="cont">{{ item2.cont }}</div>
              <div class="date">
                {{
                  dateFormat(item2.create_date)
                }}<a href="##" v-on:click="repleyShow($event)">回复</a>
              </div>
              <div class="replyarea">
                <el-input type="textarea" placeholder="请输入内容" :rows="4" v-model="rplcont2" maxlength="120"
                  show-word-limit>
                </el-input>
                <div class="replybtns">
                  <el-button type="primary" @click="
                    reply(
                      $event,
                      item2.id,
                      item.comment_id == 0 ? item.id : item.comment_id,
                      item.displayname,
                      item.uid,
                      2,
                      index
                    )
                  " plain>发表回复</el-button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.childCommentCount > childCommList[index].length">
            <CommentMore :childCommentCount="item.childCommentCount" :commentId="item.id" :id="id"></CommentMore>
          </div>
          <div style="clear: both"></div>
        </div>
        <div style="clear: both"></div>
      </div>
      <a class="load-more" href="javascript:void(0);" v-show="isShowMoreBtn" @click="loadMore()">加载更多</a>
    </div>
  </div>
</template>
<style scoped>
/*回复评论*/
.comm-cont {
  border-bottom: #e2e2e2 1px solid;
  margin-top: 32px;
  position: relative;
  padding-bottom: 32px;
}

.avatar {
  display: inline-block;
  position: absolute;
  left: 0;
}

.comm-level2 {
  margin-left: 45px;
  margin-top: 12px;
  position: relative;
}

.avatar-level2 {
  display: inline-block;
  position: absolute;
  left: 12px;
  top: 2px;
}

.avatar {
  vertical-align: middle;
  padding-top: 8px;
}

.comm-detail {
  margin-left: 55px;
}

.date,
.date a {
  color: #999;
  font-size: 14px;
}

.date a {
  margin-left: 16px;
}

.name {
  color: #757575;
  font-size: 14px;
}

.mr-10 {
  margin-right: 10px;
}

.ml-20 {
  margin-left: 20px;
}

.cont {
  padding: 16px 0 16px 0;
}

.comm-num {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}

.see-comm {
  color: #00a1d6;
  margin-left: 16px;
  font-size: 14px;
}

a:hover {
  color: #00a1d6;
}

.ava-check {
  float: left;
  padding: 8px;
  padding-right: 16px;
}

.replybtns {
  text-align: right;
  padding-top: 8px;
}

.replyarea {
  max-width: 800px;
  margin-top: 8px;
  display: none;
}

.load-more {
  font-size: 14px;
  padding: 8px;
  width: 75px;
  margin: 0 auto;
  display: block;
}
</style>
<script>
import CommentMore from "./comment_more.vue";
export default {
  components: {
    CommentMore,
  },
  data() {
    return {
      id: 0, //内容的ID，比如文章的ID
      rplcont: "",
      rplcont2: "",
      commCount: 0, //一级评论的总条数
      showCommCount: 0,//已展示一级评论的数量，需要与总条数对比，显示加载更多按钮
      showChildCommCount: 0,//已展示子(二级)评论的数量
      commTotalCount: 0, //所有评论的总条数(包含子评论)
      commList: [],
      childCommList:[[]],
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      isShowMoreBtn: false,
      pageIndex: 1,
      loginuid: 0,
    };
  },
  props: ["publishUserId", "articleId", "setCommentNum", "btnText", "hits"],
  mounted() {
    var _uid = localStorage.getItem("loginuid");
    this.loginuid = _uid == null || _uid == undefined ? 0 : parseInt(_uid);
  },
  watch: {
    articleId(newArticleId) {
      this.id = parseInt(newArticleId);
      this.getCommentCount(newArticleId);
      this.getCommentTotalCount(newArticleId);
    },
    publishUserId(newPublishUserId) {
      this.publishUserId = newPublishUserId;
    },
    commTotalCount(newNum) {
      this.setCommentNum(newNum);
    },
  },

  methods: {
    dateFormat(date) {
      return date.replace("T", " ").split(".")[0];
    },
    loadMore() {
      this.getCommentList(this.id);
    },
    getCommentList(cont_id) {
      this.$http
        .get("/api/CommentView/" + this.pageIndex + "/" + cont_id)
        .then((r) => {
          if (r.data.code == 200) {
            //this.commList[0].push.apply(this.commList[0], r.data.data[0]);
            //把二级评论分好组，与一级评论对应
            var arr1 = r.data.data;
            //this.commList = arr1;
            //var arr2 = r.data.data[1];
            // for (var i = 0; i < arr1.length; i++) {
            //   var arr3 = [];
            //   for (var j = 0; j < arr2.length; j++) {
            //     if (arr1[i].id == arr2[j].comment_id) {
            //       arr3.push(arr2[j]);
            //     }
            //   }
            //   this.commList[1].push(arr3);
            // }
            var parentCommIndex=-1;
            for (var i = 0; i < arr1.length; i++) {
              if (arr1[i].parent_id == 0) {
                //push累加，因为分页还有下一页继续累加显示到页面上
                this.commList.push(arr1[i]);
                parentCommIndex=this.commList.length-1;
                this.childCommList[parentCommIndex]=[];
                this.showCommCount++;
              } else {
                this.showChildCommCount++;
                this.childCommList[parentCommIndex].push(arr1[i]);
              }
            }
            console.log(this.childCommList);
            //console.log(this.commList);

            //this.commList[1].push.apply(this.commList[1], r.data.data[1]);
            //this.commCount总条数单独一个接口获取
            //this.isShowMoreBtn = this.commList[0].length < this.commCount;
            this.isShowMoreBtn = this.commCount > this.showCommCount;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.pageIndex++;
    },
    getCommentCount(cont_id) {
      this.$http
        .get("/api/CommentView/" + cont_id)
        .then((r) => {
          this.commCount = r.data;
          this.getCommentList(cont_id);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getCommentTotalCount(cont_id) {
      this.$http
        .get("/api/CommentView?contid=" + cont_id)
        .then((r) => {
          this.commTotalCount = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    reply(e, pid, commid, disname, uid, replyType, arrIndex) {

      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      //发表评论使用不同的富文本框，所以要判断到底是发表新的评论，还是二级（回复）评论
      var cont = this.rplcont;
      if (replyType == 2) {
        //回复别人的评论
        cont = this.rplcont2;
        if (this.rplcont2 == "") {
          this.$alert("请填写内容", "", {
            confirmButtonText: "确定",
          });
          return;
        }
      } else {
        //发表新的评论
        if (this.rplcont == "") {
          this.$alert("请填写内容", "", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      //var _articleId = this.id;
      this.$http
        .post("/api/PlayerDetailComment/", {
          cont: cont,
          parent_id: pid,
          comment_id: commid,
          cont_id: this.id,
          replied_uid: uid,
          replied_name: disname,
        })
        .then((r) => {
          console.log(r);
          if (r.data.code == 200) {
            if (replyType == 2) {
              this.rplcont2 = "";
            } else {
              this.rplcont = "";
            }
            this.$alert("评论成功", "", {
              confirmButtonText: "确定",
            });
            if (pid > 0) {
              this.repleyShow2(e);
            }
            if (replyType == 2) {
              //回复评论，因为发表的评论需要审核，所以没有必要先显示了

              //this.commList[1][arrIndex].push(r.data.data);
            } else {
              //this.commList[0].unshift(r.data.data);
            }

            console.log(this.commList);

            this.commTotalCount += 1;
            //this.getCommentList(_articleId);
            //无用的代码，只是为了保留arrIndex参数，后续可能会使用
            if (arrIndex > 0) {
              return;
            }
          } else {
            let reasonFail = "发表评论失败，请重试";
            if (r.data.msg != "") {
              reasonFail += "，原因：" + r.data.msg;
            }
            this.$alert(reasonFail, "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    repleyShow: function (e) {
      //显示和隐藏文本框
      var cur = e.currentTarget;
      var displayArea = cur.parentNode.nextSibling;
      var disstate = displayArea.style.display;
      if (disstate === "" || disstate === "none") {
        displayArea.style.display = "block";
      } else {
        displayArea.style.display = "none";
      }
    },
    repleyShow2: function (e) {
      //显示和隐藏文本框（第三级的评论框）
      var cur = e.target;
      var displayArea = cur.parentNode.parentNode;
      var disstate = displayArea.style.display;
      if (disstate === "" || disstate === "none") {
        displayArea.style.display = "block";
      } else {
        displayArea.style.display = "none";
      }
    },
  },
};
</script>
